import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { actions, SectionNames, selectors } from 'builder/modules/resumeEditor'

export const useFoldableSectionHandlers = (sectionName: SectionNames) => {
  const dispatch = useDispatch()
  const isOpened = useTypedSelector(store => selectors.isSectionOpened(store, sectionName))

  const handleToggle = useCallback(() => {
    dispatch(actions.setOpenedSections({ [sectionName]: !isOpened }))
  }, [dispatch, isOpened, sectionName])

  return {
    isOpened,
    handleToggle,
  }
}
